import React, { ReactElement } from "react";
import { Grid, Typography, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import AddTitleToBroswerTab from "../molecules/AddTitleToBroswerTab";

const useStyles = makeStyles((theme: Theme) => ({
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    color: "#000",
    lineHeight: "28px",
  },
}));
interface Props {
  heading?: string;
  pageTitle?: string;
}

export default function CardHeader({
  heading = "Enter a heading here...",
  pageTitle,
}: Props): ReactElement {
  const classes = useStyles();
  return (
    <>
      {pageTitle && <AddTitleToBroswerTab title={pageTitle} />}
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Typography className={classes.pageHeading}>{heading}</Typography>
      </Grid>
    </>
  );
}
